// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-sparklines-columns';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.656 2.808h14.616c.648 0 1.152.504 1.152 1.152v10.152c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V3.96c.072-.648.576-1.152 1.152-1.152zm2.088 7.632v1.368m2.664-4.32v4.32M9 8.424v3.384m2.592-1.656v1.656m2.664-5.04v5.04'
  />
);

export const viewBox = '0 0 18 18';
